import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "Berapa biaya perbaikan AC yang tidak dingin?",
      answer: `Biaya perbaikan AC bervariasi tergantung masalahnya:\n\n• Pembersihan filter dan evaporator: Rp 75.000 - 150.000\n• Isi ulang freon: Rp 200.000 - 400.000\n• Ganti kompresor: Rp 800.000 - 1.500.000\n• Service menyeluruh: Rp 300.000 - 600.000\n\nKami memberikan diagnosa gratis dan estimasi biaya transparan sebelum perbaikan dimulai.`,
      category: "Harga"
    },
    {
      id: 2,
      question: "Berapa lama waktu yang dibutuhkan untuk perbaikan AC?",
      answer: `Durasi perbaikan tergantung jenis masalahnya:\n\n• Cuci AC standar: 1-2 jam\n• Perbaikan ringan (isi freon, ganti filter): 1-3 jam\n• Perbaikan sedang (ganti spare part): 2-4 jam\n• Perbaikan berat (ganti kompresor): 4-8 jam\n• Bongkar pasang AC: 3-6 jam\n\nTim kami bekerja efisien tanpa mengurangi kualitas hasil.`,
      category: "Waktu"
    },
    {
      id: 3,
      question: "Apakah ada garansi untuk layanan perbaikan AC?",
      answer: `Ya, kami memberikan garansi komprehensif:\n\n• Garansi perbaikan: 2 Minggu\n• Garansi spare part original: 1 Bulan\n• Garansi instalasi baru: 1 Bulan\n• Garansi cuci AC: 1 Bulan\n\nJika ada masalah dalam periode garansi, kami akan memperbaiki gratis tanpa biaya tambahan.`,
      category: "Garansi"
    },
    {
      id: 4,
      question: "Apakah teknisi AC Service Pro bersertifikat?",
      answer: `Semua teknisi kami adalah profesional bersertifikat:\n\n• Sertifikasi HVAC Indonesia\n• Pelatihan rutin teknologi AC terbaru\n• Pengalaman minimal 5 tahun\n• Menguasai semua merk AC (Daikin, LG, Sharp, Panasonic, dll)\n• Background check dan asuransi kerja\n\nKami hanya mengirim teknisi terpercaya dan kompeten ke rumah Anda.`,
      category: "Teknisi"
    },
    {
      id: 5,
      question: "Bagaimana cara mengetahui AC perlu dibersihkan atau diperbaiki?",
      answer: `Tanda-tanda AC perlu perawatan:\n\n🔴 Perlu Dibersihkan:\n• Udara tidak segar/bau\n• Debu keluar dari AC\n• Konsumsi listrik naik\n• Suara lebih berisik\n\n🔴 Perlu Diperbaiki:\n• AC tidak dingin sama sekali\n• Air menetes/bocor\n• Suara sangat berisik\n• AC sering mati sendiri\n\nHubungi kami untuk konsultasi gratis dan diagnosa profesional.`,
      category: "Perawatan"
    },
    {
      id: 6,
      question: "Apakah layanan tersedia 24 jam?",
      answer: `Ya, kami menyediakan layanan 24/7:\n\n• Call center 24 jam setiap hari\n• WhatsApp fast response\n• Layanan darurat untuk kasus mendesak\n• Teknisi standby di seluruh Jakarta\n• Biaya layanan malam/weekend sama\n\nUntuk emergency, kami bisa datang dalam 30-60 menit tergantung lokasi.`,
      category: "Layanan"
    },
    {
      id: 7,
      question: "Area mana saja yang dilayani AC Service Pro?",
      answer: `Kami melayani seluruh Jabodetabek:\n\n✅ Jakarta (Pusat, Selatan, Timur, Barat, Utara)\n✅ Bogor dan sekitarnya\n✅ Depok dan sekitarnya\n✅ Tangerang dan sekitarnya\n✅ Bekasi dan sekitarnya\n\nUntuk area lain, silakan hubungi kami untuk konfirmasi ketersediaan layanan.`,
      category: "Area"
    },
    {
      id: 8,
      question: "Bagaimana cara pembayaran yang tersedia?",
      answer: `Kami menerima berbagai metode pembayaran:\n\n💳 Tunai (Cash)\n💳 Transfer Bank (BCA, Mandiri, BRI, BNI)\n💳 E-Wallet (GoPay, OVO, DANA, ShopeePay)\n💳 Kartu Kredit/Debit\n💳 Cicilan 0% untuk layanan premium\n\nPembayaran dilakukan setelah pekerjaan selesai dan Anda puas dengan hasilnya.`,
      category: "Pembayaran"
    }
  ];

  const categories = ["Semua", "Harga", "Waktu", "Garansi", "Teknisi", "Perawatan", "Layanan", "Area", "Pembayaran"];
  const [activeCategory, setActiveCategory] = useState("Semua");

  const filteredFAQs = activeCategory === "Semua" 
    ? faqs 
    : faqs?.filter(faq => faq?.category === activeCategory);

  const toggleFAQ = (faqId) => {
    setExpandedFAQ(expandedFAQ === faqId ? null : faqId);
  };

  const handleWhatsAppQuestion = () => {
    const message = "Halo AC Service Pro! Saya punya pertanyaan yang tidak ada di FAQ. Mohon bantuan untuk konsultasi gratis.";
    window.open(`https://wa.me/6282226648077?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="HelpCircle" size={16} className="mr-2" />
            Pertanyaan Umum
          </div>
          <h2 className="font-heading font-bold text-3xl lg:text-5xl text-foreground mb-6">
            Pertanyaan yang Sering Ditanyakan
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Temukan jawaban untuk pertanyaan umum seputar layanan AC kami. 
            Masih ada pertanyaan? Hubungi kami untuk konsultasi gratis!
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories?.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                activeCategory === category
                  ? 'bg-primary text-white shadow-md'
                  : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* FAQ List */}
        <div className="space-y-4 mb-12">
          {filteredFAQs?.map((faq) => (
            <div key={faq?.id} className="bg-white rounded-2xl shadow-card border border-border overflow-hidden">
              <button
                onClick={() => toggleFAQ(faq?.id)}
                className="w-full p-6 text-left hover:bg-muted/30 transition-colors duration-200"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1 pr-4">
                    <h3 className="font-heading font-semibold text-lg text-foreground mb-2">
                      {faq?.question}
                    </h3>
                    <div className="flex items-center">
                      <span className="bg-primary/10 text-primary px-2 py-1 rounded-full text-xs font-medium">
                        {faq?.category}
                      </span>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <Icon 
                      name={expandedFAQ === faq?.id ? "ChevronUp" : "ChevronDown"} 
                      size={24} 
                      className="text-primary" 
                    />
                  </div>
                </div>
              </button>
              
              {expandedFAQ === faq?.id && (
                <div className="px-6 pb-6 border-t border-border">
                  <div className="pt-4">
                    <div className="prose prose-sm max-w-none">
                      {faq?.answer?.split('\n')?.map((line, index) => (
                        <p key={index} className="text-muted-foreground mb-2 last:mb-0">
                          {line}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Still Have Questions */}
        <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl p-8 text-center">
          <Icon name="MessageCircle" size={48} className="text-primary mx-auto mb-4" />
          <h3 className="font-heading font-bold text-2xl text-foreground mb-4">
            Masih Ada Pertanyaan?
          </h3>
          <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
            Tim customer service kami siap membantu Anda 24/7. 
            Dapatkan konsultasi gratis dan jawaban langsung dari ahli AC profesional.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleWhatsAppQuestion}
              className="bg-secondary text-white px-8 py-3 rounded-lg font-semibold hover:bg-secondary/90 transition-colors flex items-center justify-center"
            >
              <Icon name="MessageCircle" size={20} className="mr-2" />
              Tanya via WhatsApp
            </button>
            <button
              onClick={() => window.location.href = 'tel:+6282226648077'}
              className="bg-accent text-white px-8 py-3 rounded-lg font-semibold hover:bg-accent/90 transition-colors flex items-center justify-center"
            >
              <Icon name="Phone" size={20} className="mr-2" />
              Telepon Sekarang
            </button>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-border">
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-primary mb-1">
                &lt; 5 Min
              </div>
              <div className="text-sm text-muted-foreground">Respon WhatsApp</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-secondary mb-1">
                24/7
              </div>
              <div className="text-sm text-muted-foreground">Customer Service</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-accent mb-1">
                Gratis
              </div>
              <div className="text-sm text-muted-foreground">Konsultasi</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
